<template>
    <div class="main">
      <div class="text-center">
        <span style="font-size: 10em"><i class="fa fa-bug"  aria-hidden="true"></i> 403</span><br>
        <span style="font-size: 4em">PAGE FORBIDDEN</span>
        <h1>Bạn không có quyền thực hiện tác vụ này!</h1>
      </div>
    </div>
</template>

<script type="text/javascript">
  export default {
    name: 'PermissionDenied'
  }
</script>

<style type="text/css" scoped>
  .main{
    width: 100%;
    height: calc(100vh - 60px);
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgb(68, 68, 85);
    color: rgb(161, 161, 169);
  }
</style>



// WEBPACK FOOTER //
// PermissionDenied.vue?291a5324